import {faTimes} from '@fortawesome/pro-light-svg-icons'

import {Dialog, FaIcon, LazyImage} from '@sdox/ui'

import type {DialogContentProps} from '@sdox/ui'
import type {XcNwBlock_BlockInstagramType_Fragment} from '@sdox/api'

export interface InstagramFeedProps extends DialogContentProps {
  instaBlock: XcNwBlock_BlockInstagramType_Fragment
  postIndex: number
  onClose(): void
}

export const InstagramFeed = ({instaBlock, postIndex, onClose, ...restProps}: InstagramFeedProps) => (
  <Dialog.Content
    hasAside
    {...restProps}
  >
    <div className={'relative order-2 sm:order-1'}>
      <LazyImage
        src={instaBlock.instaItems[postIndex].image.thumbnailUrl}
        alt={'instagram post'}
      />
      <div
        onClick={onClose}
        className={'absolute right-2 top-2 flex size-12 items-center justify-center rounded-full bg-black/20 sm:hidden'}
      >
        <FaIcon
          className={'size-8 cursor-pointer text-white'}
          icon={faTimes}
        />
      </div>
    </div>
    <div className={'relative order-1 w-full shrink-0 sm:order-2 sm:w-1/3'}>
      <div className={'sm:hide-scrollbar w-full sm:absolute sm:top-0 sm:h-full sm:overflow-auto'}>
        <div className={'flex items-center justify-between gap-4 border-b border-gray-200 p-5'}>
          <div className={'flex flex-row items-center gap-3'}>
            <img
              className={'h-10 rounded-full'}
              src={instaBlock.logo?.thumbnailUrl}
              alt={'instagram profil'}
            />
            <span className={'text-xs'}>{instaBlock.name}</span>
          </div>

          <a
            href={instaBlock.href}
            target={'_blank'}
            rel={'noreferrer'}
            className={'text-xs font-bold text-blue-400 focus:outline-none'}
          >
            Folgen
          </a>
        </div>
        <div className={'p-5'}>
          <p className={'mb-4 break-words text-xs sm:text-sm'}>{instaBlock.instaItems[postIndex].text}</p>
          <p className={'text-xs font-thin sm:text-sm'}>{instaBlock.instaItems[postIndex].created}</p>
        </div>
      </div>
    </div>
  </Dialog.Content>
)
